/**
 * The gutters and centred column every page's content lines up in. 1136 plus
 * 32px each side is the design's 1200 content frame.
 *
 * Shared with AppShell's banner, which rules edge to edge but keeps its
 * content here so the project header's icon tile sits above the first agent
 * card. Its own module so importing it does not pull the side nav into a
 * component's tests.
 *
 * Whole class strings: Tailwind reads them as text, so `max-w-[${w}]` emits
 * nothing.
 */
export const SHELL_GUTTERS = 'px-8';
export const SHELL_COLUMN = 'mx-auto w-full max-w-[1136px]';
